export default __webpack_public_path__ + "static/media/managingtime_sl_active.f0eb0298.png";